<script lang="ts">
	let show = $state(false);
	interface Props {
		showContent?: boolean;
		children?: import('svelte').Snippet<[any]>;
	}

	let { showContent = $bindable(false), children }: Props = $props();
</script>

<div>
	<button
		onmouseleave={() => (show = false)}
		onmouseenter={() => (show = true)}
		onclick={() => (showContent = !showContent)}
		class="w-full h-6 flex items-center"
	>
		{#if show}
			<div class="h-px w-full bg-primary-200 relative">
				<div
					class="bg-white rounded-full border-primary-200 border absolute -top-2 -left-4 h-4 w-4"
				></div>
			</div>
		{/if}
	</button>

	{#if showContent}
		<div>
			{@render children?.({ showContent })}
		</div>
	{/if}
</div>
